import React, { useState } from 'react'
import { Box, Collapse, Typography, makeStyles } from '@material-ui/core'
import { ProductCardModel } from '../../../../../server/mpsklad_core/Models/MpCard/ProductCardModel'
import { CategoryAttributeModel } from '../../../../../server/mpsklad_core/Models/MpCard/CategoryAttributeModel'
import { WbVariants } from './wbVariants'
import { Button } from '../../../../shared/ui/button'
import { VariantsEditorWb } from './wbVariantsEditor'
import { LinkCardWb } from './wbLinkCard'

type WbVariantsContainerProps = {
  existingVariants: ProductCardModel[]
  editableAttributes: CategoryAttributeModel[]
  parentCardId?: string
}

export const WbVariantsContainer: React.FC<WbVariantsContainerProps> = ({ existingVariants, editableAttributes, parentCardId }) => {
  const [expanded, setExpanded] = useState(false)
  const classes = useStyles()
  const hasVariants = existingVariants.length > 0

  return (
    <>
      <Button
        type="button"
        onClick={() => setExpanded(prev => !prev)}
        className={classes.outlineButton}
        style={{
          width: "100%", 
        }}
      >
        {expanded ? 'Свернуть управление вариантами' : 'Управление вариантами Wildberries'}
      </Button>

      <Collapse in={expanded}>
        <Box mt={2} border="1px solid #ccc" p={2} borderRadius={4}>
          {hasVariants ? (
            <>
              <WbVariants
                existingVariants={existingVariants}
                editableAttributes={editableAttributes}
              />

              {/* Добавление новых вариантов */}
              <Box mt={3}>
                <VariantsEditorWb editableAttributes={editableAttributes} parentCardIdProp={parentCardId} />
              </Box>
            </>
          ) : (
            <>
              <Typography  color="textSecondary" style={{ marginBottom: 16 }}>
                У этой карточки еще нет вариантов
              </Typography>

              {/* Только если вариантов нет — блок привязки */}
              <Box mt={2}>
                <Typography variant="subtitle2" gutterBottom>
                  Привязать эту карточку к существующей, как вариант
                </Typography>
                  <LinkCardWb variantCardId={parentCardId} />
                  или создать новый вариант этой карточки:
                  <Box mt={3}>
                    <VariantsEditorWb editableAttributes={editableAttributes} parentCardIdProp={parentCardId} />
                  </Box>
              </Box>
            </>
          )}
        </Box>
      </Collapse>
    </>
  )
}

const useStyles = makeStyles(() => ({
  outlineButton: {
    border: '2px solid #dcabd7',
    background: '#a11f94',
    marginBottom: 16,
    padding: '12px 24px',
    fontSize: '16px',
    '&:hover': {
      background: '#dcabd7',
      color: '#a11f94'
    }
  }
}))